import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'
import { Icon } from 'components/shared/Icon/Icon'
import { ChevronDownIcon, ChevronUpIcon } from 'components/shared/Icon/model'

export type CardTableOrder = {
  column: string | null
  ascending: boolean | null
}

type CardTableHeaderCellProps = {
  children?: React.ReactNode
  width?: string
  className?: string
  setOrder?: (id?: string) => void
  order?: CardTableOrder
  id?: string
}

export const CardTableHeaderCell = ({
  children,
  width = 'auto',
  className,
  setOrder,
  order,
  id,
}: CardTableHeaderCellProps) => (
  <th
    className={cx(
      styles.cardTableHeaderCell,
      {
        [styles.selectable]: Boolean(setOrder),
      },
      className,
    )}
    style={{ [`--width`]: width }}
    onClick={setOrder ? () => setOrder(id) : undefined}
  >
    {children}
    {order == null || order.ascending == null || order.column !== id ? null : (
      <span className={styles.icons}>
        <Icon
          icon={order.ascending ? ChevronUpIcon : ChevronDownIcon}
          size={20}
        />
      </span>
    )}
  </th>
)
